import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Row, Select, TextField } from '@fs/zion-ui'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { createCtrs } from '../../../services/templeService'
import { DmcDatePicker } from '../../common/DmcDatePicker/DmcDatePicker'
import initDateStandards from '../../common/DmcDateStandards'
import DmcTemplePicker from '../../common/DmcTemplePicker'
import { OwsContext } from '../OwsContext'

const initialState = {
  templeCode: '',
  performedLocalDate: '',
  ordinanceType: '',
  osids: [],
  systemType: 'DMC',
}

export default function RecordOrdinanceOverlay({ overlay }) {
  const { t } = useTranslation()
  const owsContext = useContext(OwsContext)
  const { error } = useNotifications()
  const [request, setRequest] = useState(initialState)
  const [standardDate, setStandardDate] = useState(initDateStandards())

  useEffect(() => {
    if (!overlay.isOpen && overlay.transitioning) {
      setRequest(initialState)
      setStandardDate(initDateStandards())
    }
  }, [overlay.isOpen, overlay.transitioning])

  const setOrdinanceType = (type) => {
    setRequest({
      ...request,
      ordinanceType: type,
    })
  }

  const setTemple = (temple) => {
    setRequest({
      ...request,
      templeCode: temple,
    })
  }

  const setOsid = (osid) => {
    if (osid) {
      setRequest({
        ...request,
        osids: [osid],
      })
    } else {
      setRequest({
        ...request,
        osids: [],
      })
    }
  }

  const confirmBtnOnClick = () => {
    const formalDate = standardDate.formal
    const finalRequest = {
      ...request,
      performedLocalDate: formalDate && formalDate.includes('+') ? formalDate.substring(1) : formalDate,
    }
    setStandardDate(initDateStandards())
    setRequest(initialState)
    overlay.close()
    createCtrs(finalRequest)
      .then((response) => {
        if (response.data[0].failureMessage) {
          error(response.data[0].failureMessage, null)
        } else {
          owsContext.fetchCurrentOws()
        }
      })
      .catch((err) => {
        error(
          t('ows.errors.recordingOrdinance', {
            defaultValue: `Error recording ordinance: ${err.message || ''}`,
            message: err.message || '',
          }),
          err
        )
      })
    owsContext.fetchCurrentOws()
  }

  const setSelectedDateItem = (date) => {
    if (date) {
      setStandardDate(date)
    } else {
      setStandardDate(initDateStandards())
    }
  }
  return (
    <DialogOverlay title={t('ows.recordOrdinance', 'Record Ordinance')} {...overlay}>
      <Select
        id="ctrType"
        label={t('type', 'Type')}
        placeholder={t('odm.selectType', 'Select Type')}
        value={request.ordinanceType}
        onChange={(event) => setOrdinanceType(event.target.value)}
        options={[
          {
            value: 'BAPTISM',
            label: t('ordinances.types.baptism', 'Baptism'),
          },
          {
            value: 'CONFIRMATION',
            label: t('ordinances.types.confirmation', 'Confirmation'),
          },
          {
            value: 'INITIATORY',
            label: t('ordinances.types.initiatory', 'Initiatory'),
          },
          {
            value: 'ENDOWMENT',
            label: t('ordinances.types.endowment', 'Endowment'),
          },
          {
            value: 'SEALING_TO_PARENTS',
            label: t('ordinances.types.sealingToParents', 'Sealing to Parents'),
          },
          {
            value: 'SEALING_TO_SPOUSE',
            label: t('ordinances.types.sealingToSpouse', 'Sealing to Spouse'),
          },
        ]}
      />
      <DmcTemplePicker
        onSuggestionSelected={(selection) => selection && setTemple(selection.templeCode)}
        onClear={() => setTemple()}
        fillX
      />
      <Row alignX="center">
        <TextField
          id="osidInput"
          onChange={(event) => setOsid(event.target.value)}
          value={request.osids[0]}
          label={t('osid', 'OSID')}
        />
        <DmcDatePicker selectedItem={standardDate} setSelectedItem={setSelectedDateItem} disabled={false} />
      </Row>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button
            emphasis="high"
            onClick={confirmBtnOnClick}
            disabled={
              !(request.templeCode && standardDate?.primaryText && request.ordinanceType && request.osids.length > 0)
            }
          >
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
